import { ICart } from "@Interfaces/Api/cart";
import { ApiCore } from "@Services/API/Core";
import { apiProvider } from "@Services/API/Provider";

const url = "inquiry";
const Enquiry = new ApiCore<ICart>({
  getAll: true,
  getSingle: true,
  remove: false,
  url: url,
  post: true,
  put: true,
  patch: false,
});

export { Enquiry };
